import { render, staticRenderFns } from "./01.vue?vue&type=template&id=dcebc1c8&scoped=true"
import script from "./01.vue?vue&type=script&lang=js"
export * from "./01.vue?vue&type=script&lang=js"
import style0 from "./01.vue?vue&type=style&index=0&id=dcebc1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcebc1c8",
  null
  
)

export default component.exports